// para dúvidas sobre o nome das colunas, ver: https://listastokstok.atlassian.net/browse/SOUR-655

export const headers = [
  'Registro da Alteração',
  'Nova Agenda',
  'Agenda Anterior',
  'Alterado por',
  'Motivo',
  'Unidades',
  'Agendamento original',
  'Data recusa/aceite',
  'Agenda sugerida',
  'Penalização Prazo Pagamento',
  'Desconto No Show',
  'Desconto Alteração Agenda Tardia'
];
